import React from 'react'

const Suspect = () => {
  return (
    <svg height="21" width="21" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(-45 10.5 10.5)">
        <path d="M5.6 10.5 A4.9 4.9 0 0 1 15.6 10.5 L10.5 10.5 Z" fill="red" />
        <path d="M5.6 10.5 A4.9 4.9 0 0 0 15.6 10.5 L10.5 10.5 Z" fill="green" />
        <circle cx="10.5" cy="10.5" r="0.7" fill="black" />
      </g>
    </svg>
  )
}

export default Suspect